
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { useFetchPremiumSummary } from 'queries/premiums'
import { CardStack, CardStackItem } from 'components/CardStack/CardStack'
import MyPaymentMethod from '../components/premiumsSummary/MyPaymentMethod'
import MyPayments from '../components/premiumsSummary/MyPayments'
import MyBills from '../components/premiumsSummary/MyBills'
import { Alert } from '@cmsgov/design-system'
import { Component } from '@cms-max/medicare-api-sdk'

export function PremiumsDashboardPage () {
  const { t } = useTranslation('premiumsDashboardPage')

  const { data, isError, isLoading } = useFetchPremiumSummary()

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
      printComponent={Component.Premiums}
    >
      <div className="ds-l-container">
        {!isError && (
          <CardStack>
          <CardStackItem className="ds-u-padding--3">
            <MyPaymentMethod isLoading={isLoading} summaryData={data} />
          </CardStackItem>
          <CardStackItem className="ds-u-padding--3">
            <MyPayments isLoading={isLoading} summaryData={data} />
          </CardStackItem>
          <CardStackItem className="ds-u-padding--3">
            <MyBills isLoading={isLoading} summaryData={data} />
          </CardStackItem>
        </CardStack>
        )}

        {isError && (
          <Alert variation='error' heading={t('errorAlert.heading')} className='ds-u-measure--wide'>
            {t('errorAlert.content')}
          </Alert>
        )}
      </div>
    </ContentLayout>
  )
}

export default PremiumsDashboardPage
